import React from 'react'
import { render } from 'react-dom'
import Boot from './Boot'

const Program =  <Boot />
const InBrowser = document.getElementById('root')

render( Program , InBrowser )
